// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-segment {
  width: inherit;
  margin: 0px 20px 0px 20px !important;
  height: 45px !important;
}

ion-button {
  --background: #8bc34a;
}

.time-buttons {
  display: flex;
  justify-content: space-between;
  margin: 20px;
}

ion-datetime {
  padding: 0px;
}

ion-button {
  margin: 10px 0;
}

.now-time,
.later-time {
  margin: 20px;
}

ion-list {
  max-height: 300px; /* Adjust the height */
  overflow-y: auto; /* Enable scrolling for time slots */
}

ion-item {
  --border-radius: 5px;
  border-radius: 5px;
}

ion-label {
  font-size: 16px;
}

ion-radio {
  margin-right: 10px;
}

ion-segment {
  margin: 20px;
}

ion-button {
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/time-selection-component/time-selection-component.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EAEA,oCAAA;EACA,uBAAA;AAAJ;;AAGE;EACE,qBAAA;AAAJ;;AAEE;EACE,aAAA;EACA,8BAAA;EACA,YAAA;AACJ;;AAEE;EAEE,YAAA;AAAJ;;AAGE;EACE,cAAA;AAAJ;;AAGE;;EAEA,YAAA;AAAF;;AAGA;EACE,iBAAA,EAAA,sBAAA;EACA,gBAAA,EAAA,oCAAA;AAAF;;AAGA;EACE,oBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,gBAAA;AAAF","sourcesContent":["ion-segment {\r\n    width: inherit;\r\n    // padding: 10px;\r\n    margin: 0px 20px 0px 20px !important;\r\n    height: 45px !important;\r\n\r\n  }\r\n  ion-button {\r\n    --background: #8bc34a;\r\n  }\r\n  .time-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin: 20px;\r\n  }\r\n  \r\n  ion-datetime {\r\n    // margin: 10px 0;\r\n    padding: 0px;\r\n  }\r\n  \r\n  ion-button {\r\n    margin: 10px 0;\r\n  }\r\n\r\n  .now-time,\r\n.later-time {\r\n  margin: 20px;\r\n}\r\n\r\nion-list {\r\n  max-height: 300px; /* Adjust the height */\r\n  overflow-y: auto; /* Enable scrolling for time slots */\r\n}\r\n\r\nion-item {\r\n  --border-radius: 5px;\r\n  border-radius: 5px;\r\n}\r\n\r\nion-label {\r\n  font-size: 16px;\r\n}\r\n\r\nion-radio {\r\n  margin-right: 10px;\r\n}\r\n\r\nion-segment {\r\n  margin: 20px;\r\n}\r\n\r\nion-button {\r\n  margin-top: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
